var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5 40.239C38.9505 46.2908 29.7943 45.729 29.5115 45.729C29.5115 47.5827 29.5115 85.6046 29.5115 87.9873C29.5115 88.5467 29.965 89.0002 30.5244 89.0002H37.9286C38.4283 89.0002 38.8533 88.6357 38.9297 88.1416L44.4962 52.049L50.0627 88.1416C50.1388 88.6357 50.5638 89.0002 51.0637 89.0002H58.4679C59.0273 89.0002 59.4808 88.5467 59.4808 87.9873L59.4867 45.7295C59.1596 45.7295 50.2427 46.3553 44.5 40.239Z",
    fill: "#26BC98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5316 3.04355C43.0763 3.04355 41.753 2.48591 40.7587 1.57471C42.1168 3.88349 43.1905 5.70851 44.5 7.93438C46.4105 4.68693 46.248 4.96296 48.1726 1.69135C47.1945 2.53302 45.9234 3.04355 44.5316 3.04355Z",
    fill: "#26BC98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3343 36.4747V33.6319H66.0409V33.6317V9.17482C66.0409 4.93168 62.604 1.46798 58.3341 1.46798V1.50952C57.3718 1.21193 54.6015 0.355305 53.4523 0L51.3855 7.57386L47.3426 8.33193L48.376 12.2761L43.2997 25.1983V19.0881L40.6236 12.2764L41.657 8.33228L37.6141 7.57421L35.5477 0L30.6657 1.50952V1.46798C26.4094 1.46798 22.9589 4.91812 22.9589 9.17482V33.6319H30.6655V36.4747H22.9589V40.9913C22.9589 41.5145 23.3832 41.9388 23.9064 41.9388H29.7182C30.2423 41.9388 30.6657 41.514 30.6657 40.9913C30.6657 41.5147 31.09 41.9388 31.6132 41.9388C41.1312 41.9388 44.5 33.5414 44.5 33.5414C46.7076 38.5342 51.6973 41.9388 57.3867 41.9388C57.91 41.9388 58.3343 41.5147 58.3343 40.9913C58.3343 41.5142 58.7581 41.9388 59.2818 41.9388H65.0936C65.6168 41.9388 66.0411 41.5147 66.0411 40.9913V36.4747H58.3343ZM55.8706 18.5833H50.8169V15.7408H55.8706V18.5833Z",
    fill: "#26BC98"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 89,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloth);
export default __webpack_public_path__ + "static/media/cloth.71efb97fd3148a7022220b1b1071a02c.svg";
export { ForwardRef as ReactComponent };